'use client';

import Link from '@eliadmin/core/src/components/link';

import { useGlobalStore } from '@eliadmin/core/src/stores/global-store';
import { ContactTabContainer, ContactTabIcon, ContactTabTitle } from '../contact-tabs';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { Button } from '../../ui/button';
import { Separator } from '@eliadmin/core/src/components/ui/separator';
import { HtmlRendererRaw } from '@eliadmin/core/src/components/ui/html-renderer-raw';

export function ContactTabsCompany({ opening1, opening2 }: { opening1: string; opening2: string }) {
  const generalLayout = useGlobalStore(state => state.generalLayout);
  const { t } = useTranslations();

  return (
    <ContactTabContainer>
      <div className="flex w-full items-start justify-between gap-4">
        <div className="flex w-full flex-col items-start justify-start gap-4">
          <ContactTabTitle title={t('text617')} />
          <div className="flex w-full flex-col items-start justify-start gap-2">
            <p className="text-sm font-light sm:text-base">{generalLayout.contact?.company}</p>
            <p className="text-sm font-light sm:text-base">
              {generalLayout.contact?.operationAddress}
            </p>
            <p className="text-sm font-light sm:text-base">
              {generalLayout.contact?.operationPostCode} {generalLayout.contact?.operationCity}
            </p>
            <p className="text-sm font-light sm:text-base">{generalLayout.contact?.country.name}</p>
          </div>
          <Button asChild>
            <Link
              prefetch={false}
              target="_blank"
              href={
                'https://www.google.com/maps/place/Altanky-Domceky.sk+-+alt%C3%A1nky,+z%C3%A1hradne+dom%C4%8Deky,+chaty,+sauny+a+in%C3%A9+drevostavby/@49.3219926,19.5453975,17z/data=!3m1!4b1!4m6!3m5!1s0x4715b8be3626fe1f:0xf267c4938af5929a!8m2!3d49.3219926!4d19.5453975!16s%2Fg%2F11ck4472p_?entry=ttu&g_ep=EgoyMDI1MDcxNi4wIKXMDSoASAFQAw%3D%3D'
              }
            >
              {t('text2375')}
            </Link>
          </Button>
        </div>
        <ContactTabIcon alt={t('text690')} imageUrl="/images/icons/mobile.svg" />
      </div>
      <Separator className="bg-black/5" />
      <div className="flex w-full items-start justify-between gap-4">
        <div className="flex w-full flex-col items-start justify-start gap-4">
          <ContactTabTitle title={t('text690')} />
          <div className="flex w-full flex-col items-start justify-start gap-2">
            <HtmlRendererRaw
              as="p"
              className="opening-hours text-sm font-light sm:text-base"
              html={opening1}
            />
            <HtmlRendererRaw
              as="p"
              className="opening-hours text-sm font-light sm:text-base"
              html={opening2}
            />
          </div>
        </div>
        <ContactTabIcon alt={t('text690')} imageUrl="/images/icons/opening-hours.svg" />
      </div>
      <Separator className="bg-black/5" />
      <div className="flex w-full items-start justify-between gap-4">
        <div className="flex w-full flex-col items-start justify-start gap-4">
          <ContactTabTitle title={t('text360')} />
          <div className="flex w-full flex-col items-start justify-start gap-2">
            <Link
              prefetch={false}
              href={`mailto:${generalLayout.contact?.email}`}
              target="_blank"
              className="textsm font-semibold text-primary transition-all hover:opacity-90 sm:text-base"
            >
              {generalLayout.contact?.email}
            </Link>
            <Link
              prefetch={false}
              href={`tel:${generalLayout.contact?.phone}`}
              target="_blank"
              className="textsm font-semibold text-primary transition-all hover:opacity-90 sm:text-base"
            >
              {generalLayout.contact?.phone}
            </Link>
          </div>
        </div>
        <ContactTabIcon alt={t('text360')} imageUrl="/images/icons/mobile.svg" />
      </div>
    </ContactTabContainer>
  );
}
